<div class="card mt-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbAstreinte"></p-breadcrumb>
</div>

<div class="card mt-4">

    <div class="mb-4">

        <div class="font-semibold text-xl">Liste des Astreintes & Gestion des critères - {{this.nomDo}} - {{this.do}}</div>
        <div class="flex gap-2 justify-end">
            <p-button (onClick)="activeTab = 0" [rounded]="true" label="1" styleClass="w-2rem h-2rem p-0"
                [outlined]="activeTab !== 0" />
            <p-button (onClick)="activeTab = 1" [rounded]="true" label="2" styleClass="w-2rem h-2rem p-0"
                [outlined]="activeTab !== 1" />
        </div>
          <p-tabs [(value)]="activeTab">
            <p-tablist>
                <p-tab [value]="0"><i class="pi pi-calendar"></i> Planning Astreinte </p-tab>
                <p-tab [value]="1"><i class="pi pi-cog"></i> Gestion des critères </p-tab>
            </p-tablist>
            <p-tabpanels>


            <!-- Liste des Astreintes + Gestio des planning Astrintes -->

    <p-tabpanel [value]="0">
    <p-toolbar styleClass="mb-6">
        <ng-template #start>
            <p-button label="Ajouter" (onClick)="openNewAstreinte()" icon="pi pi-plus" class="mr-2" />
            <p-button severity="secondary" label="Supprimer" icon="pi pi-trash" outlined
                [style]="{'color': 'var(--primary-color)'}"
                [disabled]="!selectedAstreintes || !selectedAstreintes.length" (onClick)="deleteSelectedAstreintes()" />
        </ng-template>

        <!-- <ng-template #end>
                <p-button label="Export" icon="pi pi-upload" severity="secondary" (onClick)="exportCSV()" />
            </ng-template> -->
    </p-toolbar>
    <p-table #dt1 dataKey="code_interne" [value]="astreintes" [rows]="10" [rowHover]="true" [showGridlines]="true"
        [paginator]="true" [loading]="loading" [(selection)]="selectedAstreintes"
        [globalFilterFields]="['code_interne', 'code_DO', 'code_Page', 'Astreinte_Nom', 'DateHeureDebut', 'DateHeureFin', 'DateHeureDebutTr2', 'DateHeureFinTr2', 'TypeHOHNO', 'Commentaire', 'Priorite', 'DateModif']"
        responsiveLayout="scroll" [tableStyle]="{ 'min-width': '75rem' }"
        currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} astreintes"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPageOptions">
        <ng-template #caption>
            <div class="flex justify-between items-center flex-column sm:flex-row">
                <button pButton label="Réintialiser" class="p-button-outlined mb-2" icon="pi pi-filter-slash"
                    (click)="clear(dt1)"></button>
                <p-iconfield iconPosition="left" class="ml-auto">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Rechercher..." />
                </p-iconfield>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 2rem">
                    <p-tableHeaderCheckbox />
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Code Astreinte
                        <p-columnFilter type="text" field="code_interne" display="menu"
                            placeholder="Rechercher par code interne"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Page
                        <p-columnFilter type="text" field="code_Page" display="menu"
                            placeholder="Rechercher par page"></p-columnFilter>
                    </div>
                </th>
                 <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Priorité
                        <p-columnFilter type="text" field="Priorite" display="menu"
                            placeholder="Rechercher par priorité"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Astreinte
                        <p-columnFilter type="text" field="Astreinte_Nom" display="menu"
                            placeholder="Rechercher par astreinte"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Date/Heure Début
                        <p-columnFilter type="date" field="DateHeureDebut" display="menu"
                            [matchMode]="'dateIs'" placeholder="dd/mm/yyyy"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Date/Heure Fin
                        <p-columnFilter type="date" field="DateHeureFin" display="menu"
                           [matchMode]="'dateIs'" placeholder="dd/mm/yyyy"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Date/Heure Début 2
                        <p-columnFilter type="date" field="DateHeureDebutTr2" display="menu"
                            [matchMode]="'dateIs'" placeholder="dd/mm/yyyy"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Date/Heure Fin 2
                        <p-columnFilter type="date" field="DateHeureFinTr2" display="menu"
                            [matchMode]="'dateIs'" placeholder="dd/mm/yyyy"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Type horaire
                        <p-columnFilter type="text" field="TypeHOHNO" display="menu"
                            placeholder="Rechercher par type horaire"></p-columnFilter>
                    </div>
                </th>
                <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Commentaire
                        <p-columnFilter type="text" field="Commentaire" display="menu"
                            placeholder="Rechercher par commentaire"></p-columnFilter>
                    </div>
                </th>
                   <th style="width: max-content; font-weight: bold;">
                    <div class="flex justify-between items-center">
                        Date Modification
                        <p-columnFilter type="date" field="DateModif" display="menu"
                          [matchMode]="'dateIs'" placeholder="dd/mm/yyyy"></p-columnFilter>
                    </div>
                </th>
                <th style="width: 6rem; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-center items-center">
                        Actions
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-astreinte>
            <tr>
                <td style="width: 3rem">
                    <p-tableCheckbox [value]="astreinte" />
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ astreinte.code_interne }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ astreinte.code_Page }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ astreinte.Priorite }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span class="image-text">{{ astreinte.Astreinte_Nom }}</span>
                    </div>
                </td>
                <td>
                    {{ astreinte.DateHeureDebut | date: 'dd/MM/yyyy HH:mm a' }}
                </td>
                <td>
                    {{ astreinte.DateHeureFin | date: 'dd/MM/yyyy HH:mm a' }}
                </td>
                <td>
                    {{ astreinte.DateHeureDebutTr2 | date: 'dd/MM/yyyy HH:mm a' }}
                </td>
                <td>
                    {{ astreinte.DateHeureFinTr2 | date: 'dd/MM/yyyy HH:mm a' }}
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span class="image-text">{{ astreinte.TypeHOHNO }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex items-center gap-2">
                        <span>{{ astreinte.Commentaire }}</span>
                    </div>
                </td>
                <td>
                    {{ astreinte.DateModif | date: 'dd/MM/yyyy HH:mm a' }}
                </td>
                <td>
                    <div class="flex items-center justify-center">
                        <p-button icon="pi pi-eye" (onClick)="openDetailsAstreinte(astreinte)" class="mr-1"
                            [rounded]="true" [outlined]="true" />
                        <p-button icon="pi pi-pencil" (onClick)="openEditAstreinte(astreinte)" severity="danger"
                            [rounded]="true" class="mr-1" [outlined]="true" />
                        <p-button icon="pi pi-trash" (click)="deleteByAstreinte(astreinte)" severity="danger"
                            [rounded]="true" [outlined]="true" />
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="15">Aucun astreinte trouvé.</td>
            </tr>
        </ng-template>
        <ng-template #loadingbody>
            <tr>
                <td colspan="15">Chargement des données astreintes. Veuillez patienter.</td>
            </tr>
        </ng-template>
    </p-table>

    <!-- Bloc d'ajout  de l'astreinte -->
    <p-dialog [(visible)]="addastreinteDialog" [style]="{ width: '1000px' }" header="Ajouter Astreinte" [modal]="true">
        <ng-template #content>
            <div class="flex flex-col gap-6">

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code DO</label>
                        <input type="text" pInputText [(ngModel)]="do" [value]="this.do" disabled class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Page</label>
                        <p-select [options]="pagesAstreinteList" [(ngModel)]="astreinte.code_Page" [filter]="true" [checkmark]="true" [showClear]="true"
                            optionLabel="Nom_Page" placeholder="Sélectionner une page" class="w-full"></p-select>
                    </div>
                </div>

                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="font-semibold text-xl"> Segmentation des horaires</div>

                <div class="mb-4">
                        <label class="block font-bold mb-2">Type de segmentation <span class="text-red-500">*</span> </label>
                        <div class="flex items-center gap-4">
                            <div class="flex items-center">
                                  <p-radiobutton
                                    inputId="1"
                                    name="segmentationType"
                                    value="1"
                                    [(ngModel)]="segmentationType"
                                    (onClick)="setSegmentationType(1)">
                                </p-radiobutton>
                                <label for="1" class="leading-none ml-2">Période continue</label>
                            </div>
                            <div class="flex items-center">
                                 <p-radiobutton
                                        inputId="0"
                                        name="segmentationType"
                                        value="0"
                                        [(ngModel)]="segmentationType"
                                        (onClick)="setSegmentationType(0)"
                                        class="mt-1">
                                    </p-radiobutton>
                                    <div class="flex flex-col">
                                     <label for="tranches" class="leading-none ml-2 mt-4">Période non continue</label>
                                     <p-message severity="info" class="text-xs ml-2" variant="simple" size="small"> (Répétition chaque jour) </p-message>
                                    </div>
                            </div>
                        </div>
                    </div>

                    <!-- Bloc pour segmentation continue -->
                <div *ngIf="showSegmentRange">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div class="p-fluid">
                            <label class="block font-bold mb-2">Date/Heure début <span class="text-red-500">*</span> </label>
                            <p-calendar [(ngModel)]="astreinte.DateHeureDebut" [showTime]="true" [showIcon]="true"
                                inputId="DateHeureDebut" placeholder="Sélectionnez une date de début"
                                [inputStyle]="{'width':'500px'}"
                                [style]="{'overflow': 'visible', 'z-index': '999'}"
                                [class]="{'p-invalid': submitted && !astreinte.DateHeureDebut}" class="w-full"></p-calendar>
                            <p-message *ngIf="submitted && !astreinte.DateHeureDebut" severity="error" variant="simple"
                                size="small">La date de début est obligatoire</p-message>
                        </div>
                        <div class="p-fluid">
                            <label class="block font-bold mb-2">Date/Heure fin <span class="text-red-500">*</span> </label>
                            <p-calendar [(ngModel)]="astreinte.DateHeureFin" [showTime]="true" [showIcon]="true"
                                inputId="DateHeureFin" [minDate]="astreinte.DateHeureDebut" placeholder="Sélectionnez une date de fin"
                                [inputStyle]="{'width':'500px'}"
                                [style]="{'overflow': 'visible', 'z-index': '999'}"
                                [class]="{'p-invalid': submitted && !astreinte.DateHeureFin}" class="w-full"></p-calendar>
                            <p-message *ngIf="submitted && !astreinte.DateHeureFin" severity="error" variant="simple"
                                size="small">La date de fin est obligatoire</p-message>
                        </div>
                    </div>
                </div>

                <!-- Bloc pour segmentation non continue (par tranches) -->
                <div *ngIf="!showSegmentRange">

                <!-- Pour les dates -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div class="p-fluid">
                        <label class="block font-bold mb-2">Date début <span class="text-red-500">*</span></label>
                        <p-datepicker [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                            placeholder="Sélectionnez une date de début"
                            [(ngModel)]="dateDebut"
                            (onSelect)="logTimeRanges()"
                            [inputStyle]="{'width':'500px'}"
                            class="w-full" />
                            <p-message *ngIf="submitted && !dateDebut" severity="error" variant="simple"
                                size="small">La date de début est obligatoire</p-message>
                    </div>
                    <div class="p-fluid">
                        <label class="block font-bold mb-2">Date fin <span class="text-red-500">*</span></label>
                        <p-datepicker [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                            placeholder="Sélectionnez une date de fin"
                            [(ngModel)]="dateFin"
                            (onSelect)="logTimeRanges()"
                            [inputStyle]="{'width':'500px'}"
                            [class]="{'p-invalid': submitted && (!dateFin || (dateFin && dateDebut && dateFin < dateDebut))}"
                            class="w-full" />
                         <p-message *ngIf="submitted && !dateFin" severity="error" variant="simple"
                            size="small">La date de fin est obligatoire</p-message>
                         <p-message  *ngIf="submitted && dateFin && dateDebut && dateFin < dateDebut" severity="error" variant="simple"
                            size="small">La date de fin doit être supérieure ou égale à la date de début</p-message>
                    </div>
                </div>

                <!-- Pour les heures -->
                <div *ngFor="let range of timeRanges; let i = index" class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                    <div class="p-fluid">
                        <label class="block font-bold mb-2">Heure début <span class="text-red-500">*</span></label>
                        <p-datepicker
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            [timeOnly]="true"
                            [inputId]="'startTime_' + i"
                            placeholder="Sélectionnez l'heure de début"
                            [(ngModel)]="range.start"
                            (onSelect)="logTimeRanges()"
                            [inputStyle]="{'width':'500px'}"
                             [class]="{'p-invalid': submitted && ((i === 0 && !range.start) || (i > 0 && (range.start && !range.end)))}"
                            class="w-full">
                            <ng-template #inputicon let-clickCallBack="clickCallBack">
                                <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                            </ng-template>
                        </p-datepicker>
                           <p-message *ngIf="submitted && i === 0 && !range.start" severity="error" variant="simple"
                                 size="small">L'heure de début est obligatoire </p-message>
                    </div>

                    <div class="p-fluid">
                        <label class="block font-bold mb-2">Heure fin <span class="text-red-500">*</span></label>
                        <p-datepicker
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            [timeOnly]="true"
                            [inputId]="'endTime_' + i"
                            placeholder="Sélectionnez l'heure de fin"
                            [(ngModel)]="range.end"
                            (onSelect)="logTimeRanges()"
                            [inputStyle]="{'width':'500px'}"
                            [class]="{'p-invalid': submitted && ((i === 0 && !range.end) || (i > 0 && (!range.start && range.end)) || (range.start && range.end && range.end <= range.start))}"
                            class="w-full">
                            <ng-template #inputicon let-clickCallBack="clickCallBack">
                                <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                            </ng-template>
                        </p-datepicker>
                         <p-message *ngIf="submitted && i === 0 && !range.end" severity="error" variant="simple"
                                size="small">L'heure de fin est obligatoire</p-message>
                            <p-message *ngIf="submitted && i > 0 && range.end && !range.start" severity="error" variant="simple"
                                size="small">Veuillez aussi renseigner l'heure de début</p-message>
                            <!-- <p-message *ngIf="submitted && range.start && range.end && range.end <= range.start" severity="error" variant="simple"
                                size="small">L'heure de fin doit être supérieure à l'heure de début</p-message> -->
                    </div>

                    <!-- Boutons d'ajout/suppression -->
                    <div class="flex gap-2 mt-2 sm:col-span-2">
                        <p-button  *ngIf="i === 0"
                        icon="pi pi-plus"
                        (click)="addTimeRange()"
                        [disabled]="timeRanges.length >= 2"
                        severity="secondary"
                        label="Ajouter une autre tranche horaire">
                        </p-button>

                        <p-button
                        *ngIf="timeRanges.length > 1 && i === timeRanges.length - 1"
                        icon="pi pi-minus"
                        (click)="removeTimeRange()"
                        severity="danger">
                        </p-button>
                    </div>
                    </div>


                </div>

                 <div class="mb-4">
                        <label class="block font-bold mb-2">Type des horaires <span class="text-red-500">*</span></label>
                        <div class="flex items-center gap-4">
                            <ng-container *ngFor="let item of typesHO">
                                <div class="flex items-center">
                                <p-radiobutton
                                    [inputId]="item.type_HO"
                                    name="horaireType"
                                    [value]="item.type_HO"
                                    [(ngModel)]="horaireType">
                                </p-radiobutton>

                                <label 
                                    class="leading-none ml-2" 
                                    [for]="item.type_HO">
                                    {{ item.type_HO }}
                                </label>
                                </div>
                            </ng-container>
                        </div>
                        <p-message *ngIf="submitted && !horaireType" severity="error" variant="simple"
                                size="small">Le type d'horaire est obligatoire</p-message>
                 </div>
                

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <!-- Priorité -->
                            <div class="mb-4">
                                <label class="block font-bold mb-2">Priorité <span class="text-red-500">*</span></label>
                                <p-select [(ngModel)]="prioriteValue" [options]="prioriteValues" placeholder="Sélectionner la priorité" class="w-full"
                                [filter]="true"  />
                                <p-message *ngIf="submitted && !prioriteValue" severity="error" variant="simple"
                                    size="small">La priorité est obligatoire</p-message>
                            </div>
                        <!-- Commentaire -->
                            <div class="mb-4">
                                <label class="block font-bold mb-2">Commentaire</label>
                                <textarea pTextarea [(ngModel)]="astreinte.Commentaire" placeholder="Saisir votre commentaire ..." class="w-full" 
                                  [autoResize]="true" [rows]="1" [cols]="30"></textarea>
                            </div>                
                </div>


               <p-divider class="w-full bg-surface-200"></p-divider>
                    <div class="font-semibold text-xl"> Les critères</div>
                    <div class="grid grid-cols-1 sm:grid-cols-1 gap-1">
                    <!-- Affichage des critères existants -->
                        <div *ngIf="criteres.length > 0">
                            <div *ngFor="let critere of criteres ; let i = index">
                                <label class="block font-bold mb-2">{{critere.Libelle}}</label>
                                <input type="text" pInputText  [(ngModel)]="critereValues[critere.Critere]" class="w-full" />
                            </div>
                        </div>
                        <!-- Message d'information si aucun critères défini -->
                        <div *ngIf="criteres.length === 0">
                            <p-message severity="info" variant="simple" size="small" class="mt-2">
                                Aucun critère défini
                            </p-message>
                        </div>
                    </div>



                <p-divider class="w-full bg-surface-200"></p-divider>

                <div class="font-semibold text-xl">Astreinte principale <span class="text-red-500">*</span></div>
                <p-select optionLabel="Astreinte_Nom" [options]="astreintesList" [filter]="true"  [checkmark]="true" [showClear]="true"
                    [(ngModel)]="selectedAstreintePrincipale" placeholder="Sélectionner une astreinte principale"
                    class="w-full"  appendTo="body" dropdownPosition="auto"></p-select>
                <p-message *ngIf="submitted && !selectedAstreintePrincipale" severity="error" variant="simple"
                    size="small">L'astreinte principale est obligatoire</p-message>

                <!-- Section Escalade -->
                <div class="font-semibold text-xl">Les escalades</div>

                <!-- Bouton pour ajouter la première escalade -->
                <div *ngIf="getEscaladeLevels().length === 0">
                    <p-button label="Ajouter une escalade" icon="pi pi-plus" (click)="addEscaladeLevel(0)"
                        severity="secondary"></p-button>
                </div>

                <div *ngIf="getEscaladeLevels().length > 0">
                    <div *ngFor="let level of getEscaladeLevels()"
                        class="mb-4 p-4 border-round border-1 surface-border">
                        <div class="flex items-center gap-2 mb-8">
                            <div class="flex-grow">
                                <label class="block font-bold mb-2">Escalade {{level}}</label>
                                <p-select [options]="astreintesList" appendTo="body" dropdownPosition="auto" [filter]="true" [checkmark]="true" [(ngModel)]="selectedEscalades[level].astreinte"
                                    optionLabel="Astreinte_Nom" placeholder="Sélectionner" class="w-full">
                                </p-select>
                            </div>
                            <div class="flex gap-2 mt-5">
                                <p-button *ngIf="level === getEscaladeLevels().length && level < maxEscaladeLevels"
                                    icon="pi pi-plus" (click)="addEscaladeLevel(level)"
                                    [disabled]="!selectedEscalades[level].astreinte" severity="secondary"></p-button>

                                <!-- Permettre de supprimer n'importe quelle escalade, y compris la première -->
                                <p-button icon="pi pi-minus" (click)="removeEscaladeLevel(level)"
                                    severity="danger"></p-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </ng-template>

        <ng-template #footer>
            <p-button label="Annuler" icon="pi pi-times" text (click)="hideAddDialog()" />
            <p-button label="Enregistrer" icon="pi pi-save" (click)="validateAndSave()" [disabled]="isDisable" />
        </ng-template>
    </p-dialog>
    <!-- Bloc détails de l'astreinte -->
    <p-dialog [(visible)]="detailsastreinteDialog" [style]="{ width: '1000px' }" header="Astreinte Details"
        [modal]="true">
        <ng-template #content>
            <div class="flex flex-col gap-6" *ngIf="selectedAstreinte">

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Code DO</label>
                        <input type="text" pInputText [value]="selectedAstreinte.code_DO" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Page</label>
                        <input type="text" pInputText [value]="selectedAstreinte.code_Page" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Astreinte</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Astreinte_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>
<hr>
                <div class="font-semibold text-xl"> Segmentation des horaires</div>

                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label class="block font-bold mb-2">Type de segmentation</label>
                                <input type="text" pInputText
                                    [value]="selectedAstreinte.TypeSegment === 1 ? 'Continue' : 'Non continue'"
                                    [readOnly]="true"
                                    class="w-full" />
                        </div>
                        <div>
                            <label class="block font-bold mb-2">Type des horaires</label>
                            <input type="text" pInputText [value]="selectedAstreinte.TypeHOHNO "
                                [readOnly]="true" class="w-full" />
                        </div>
                 </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Date début</label>
                        <input type="text" pInputText [value]="selectedAstreinte.DateHeureDebut | date: 'dd/MM/yyyy'"
                            [readOnly]="true" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Date fin</label>
                        <input type="text" pInputText [value]="selectedAstreinte.DateHeureFin | date: 'dd/MM/yyyy'"
                            [readOnly]="true" class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Heure début TR1</label>
                        <input type="text" pInputText [value]="selectedAstreinte.DateHeureDebut | date: 'HH:mm a'"
                            [readOnly]="true" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Heure fin TR1</label>
                        <input type="text" pInputText [value]="selectedAstreinte.DateHeureFin | date: 'HH:mm a'"
                            [readOnly]="true" class="w-full" />
                    </div>
                </div>
                 <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Heure début TR 2</label>
                        <input type="text" pInputText [value]="selectedAstreinte.DateHeureDebutTr2 | date: 'HH:mm a'"
                            [readOnly]="true" class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Heure fin TR2</label>
                        <input type="text" pInputText [value]="selectedAstreinte.DateHeureFinTr2 | date: 'HH:mm a'"
                            [readOnly]="true" class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                         <label class="block font-bold mb-2">Priorité</label>
                         <input type="text" pInputText
                                  [value]="selectedAstreinte.Priorite"
                                   [readOnly]="true"
                                   class="w-full" />
                       </div>
                        <div>
                            <label class="block font-bold mb-2">Commentaire</label>
                            <textarea pTextarea [rows]="1" [cols]="30"
                                [value]="selectedAstreinte.Commentaire" 
                                [readOnly]="true" class="w-full"></textarea>
                         </div>                  
                </div>

<hr>

                    <div class="font-semibold text-xl"> Les critères</div>
                    <div class="grid grid-cols-1 sm:grid-cols-1 gap-1">
                    <!-- Affichage des critères existants -->
                        <div *ngIf="criteres.length > 0">
                            <div *ngFor="let critere of criteres ; let i = index">
                                <label class="block font-bold mb-2">{{critere.Libelle}}</label>
                                <input type="text" pInputText [(ngModel)]="critereValues[critere.Critere]" [readOnly]="true" class="w-full" />
                            </div>
                        </div>
                    </div>

<hr>
                <!-- les escalades  -->

        <div class="font-semibold text-xl">Les escalades </div>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Escalade 1</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade1_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 2</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade2_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 3</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade3_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Escalade 4</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade4_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 5</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade5_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 6</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade6_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Escalade 7</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade7_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 8</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade8_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 9</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade9_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Escalade 10</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade10_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 11</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade11_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 12</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade12_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                        <label class="block font-bold mb-2">Escalade 13</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade13_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 14</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade14_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                    <div>
                        <label class="block font-bold mb-2">Escalade 15</label>
                        <input type="text" pInputText [value]="selectedAstreinte.Escalade15_Nom" [readOnly]="true"
                            class="w-full" />
                    </div>
                </div>


    <hr>
                <!-- les escalades  -->

        <div class="font-semibold text-xl">Historique des actions</div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                         <label class="block font-bold mb-2">Date de création</label>
                         <input type="text" pInputText
                                  [value]="selectedAstreinte.InsertDateTime | date: 'dd/MM/yyyy HH:mm a'"
                                   [readOnly]="true"
                                   class="w-full" />
                       </div>
                        <div>
                            <label class="block font-bold mb-2">Date de modification</label>
                              <input type="text" pInputText
                                  [value]="selectedAstreinte.DateModif | date: 'dd/MM/yyyy HH:mm a'"
                                   [readOnly]="true"
                                   class="w-full" />
                         </div>                  
                </div>

            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDetailsDialog()" />
        </ng-template>
    </p-dialog>

    <!-- Bloc de modification de l'astreinte -->
  <p-dialog [(visible)]="editastreinteDialog" [style]="{ width: '1000px' }" header="Modifier Astreinte" [modal]="true">
    <ng-template #content>
        <div class="flex flex-col gap-6">

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label class="block font-bold mb-2">Code DO</label>
                    <input type="text" pInputText [(ngModel)]="do" [value]="this.do" disabled class="w-full" />
                </div>
                <div>
                    <label class="block font-bold mb-2">Page</label>
                    <p-select [options]="pagesAstreinteList" [(ngModel)]="astreinte.code_Page" [filter]="true" [checkmark]="true" [showClear]="true"
                        optionLabel="Nom_Page" placeholder="Sélectionner une page" class="w-full"></p-select>
                </div>
            </div>

            <p-divider class="w-full bg-surface-200"></p-divider>

            <div class="font-semibold text-xl">Segmentation des horaires</div>

            <div class="mb-4">
                <label class="block font-bold mb-2">Type de segmentation <span class="text-red-500">*</span></label>
                <div class="flex items-center gap-4">
                    <div class="flex items-center">
                        <p-radiobutton
                            inputId="1"
                            name="segmentationType"
                            value="1"
                            [(ngModel)]="astreinte.segmentationType"
                            (onClick)="setSegmentationType(1)">
                        </p-radiobutton>
                        <label for="1" class="leading-none ml-2">Période continue</label>
                    </div>
                    <div class="flex items-center">
                        <p-radiobutton
                            inputId="0"
                            name="segmentationType"
                            value="0"
                            [(ngModel)]="astreinte.segmentationType"
                            (onClick)="setSegmentationType(0)"
                            class="mt-1">
                        </p-radiobutton>
                        <div class="flex flex-col">
                            <label for="tranches" class="leading-none ml-2 mt-4">Période non continue</label>
                            <p-message severity="info" class="text-xs ml-2" variant="simple" size="small">(Répétition chaque jour)</p-message>
                        </div>
                    </div>
                </div>               
            </div>

 <!-- SEGMENTATION CONTINUE -->
<div *ngIf="astreinte.segmentationType == 1" class="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div class="p-fluid">
        <label class="block font-bold mb-2">Date/Heure début <span class="text-red-500">*</span></label>
        <p-calendar [(ngModel)]="astreinte.DateHeureDebut" [showTime]="true" [showIcon]="true"
            placeholder="Sélectionnez une date de début" class="w-full" [inputStyle]="{'width':'500px'}"
            [class]="{'p-invalid': submitted && !astreinte.DateHeureDebut}">
        </p-calendar>
        <p-message *ngIf="submitted && !astreinte.DateHeureDebut" severity="error" size="small">
            La date de début est obligatoire
        </p-message>
    </div>
    <div class="p-fluid">
        <label class="block font-bold mb-2">Date/Heure fin <span class="text-red-500">*</span></label>
        <p-calendar [(ngModel)]="astreinte.DateHeureFin" [showTime]="true" [showIcon]="true"
            [minDate]="astreinte.DateHeureDebut" placeholder="Sélectionnez une date de fin" [inputStyle]="{'width':'500px'}"
            class="w-full" [class]="{'p-invalid': submitted && !astreinte.DateHeureFin}">
        </p-calendar>
        <p-message *ngIf="submitted && !astreinte.DateHeureFin" severity="error" size="small">
            La date de fin est obligatoire
        </p-message>
    </div>
</div>
<!-- SEGMENTATION NON CONTINUE -->
<div *ngIf="astreinte.segmentationType == 0" >
    <!-- Pour les dates -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="p-fluid">
                        <label class="block font-bold mb-2">Date début <span class="text-red-500">*</span></label>
                        <p-datepicker [iconDisplay]="'input'" [showIcon]="true"
                            placeholder="Sélectionnez une date de début"
                            [(ngModel)]="dateDebut"
                            (onSelect)="logTimeRanges()"
                            [inputStyle]="{'width':'500px'}"
                            class="w-full" />
                        <p-message *ngIf="submitted && !dateDebut" severity="error" variant="simple"
                            size="small">La date de début est obligatoire</p-message>
            </div>
            <div class="p-fluid">
                        <label class="block font-bold mb-2">Date fin <span class="text-red-500">*</span></label>
                        <p-datepicker [iconDisplay]="'input'" [showIcon]="true"
                            placeholder="Sélectionnez une date de fin"
                            [(ngModel)]="dateFin"
                            (onSelect)="logTimeRanges()"
                            [inputStyle]="{'width':'500px'}"
                            [class]="{'p-invalid': submitted && (!dateFin || (dateFin && dateDebut && dateFin < dateDebut))}"
                            class="w-full" />
                        <p-message *ngIf="submitted && !dateFin" severity="error" variant="simple"
                            size="small">La date de fin est obligatoire</p-message>
                        <p-message *ngIf="submitted && dateFin && dateDebut && dateFin < dateDebut" severity="error" variant="simple"
                            size="small">La date de fin doit être supérieure ou égale à la date de début</p-message>
            </div>
    </div>

    <!-- Pour les heures -->
    <div *ngFor="let range of timeRanges; let i = index" class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
        <div class="p-fluid">
            <label class="block font-bold mb-2">Heure début <span class="text-red-500">*</span></label>
            <p-datepicker
                [iconDisplay]="'input'"
                [showIcon]="true"
                [timeOnly]="true"
                [inputId]="'startTime_' + i"
                placeholder="Sélectionnez l'heure de début"
                [(ngModel)]="range.start"
                (onSelect)="logTimeRanges()"
                [inputStyle]="{'width':'500px'}"
                [class]="{'p-invalid': submitted && ((i === 0 && !range.start) || (i > 0 && (range.start && !range.end)))}"
                class="w-full">
                <ng-template #inputicon let-clickCallBack="clickCallBack">
                    <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                </ng-template>
            </p-datepicker>
            <p-message *ngIf="submitted && i === 0 && !range.start" severity="error" variant="simple"
                size="small">L'heure de début est obligatoire</p-message>
        </div>

        <div class="p-fluid">
            <label class="block font-bold mb-2">Heure fin <span class="text-red-500">*</span></label>
            <p-datepicker
                [iconDisplay]="'input'"
                [showIcon]="true"
                [timeOnly]="true"
                [inputId]="'endTime_' + i"
                placeholder="Sélectionnez l'heure de fin"
                [(ngModel)]="range.end"
                (onSelect)="logTimeRanges()"
                [inputStyle]="{'width':'500px'}"
                [class]="{'p-invalid': submitted && ((i === 0 && !range.end) || (i > 0 && (!range.start && range.end)) || (range.start && range.end && range.end <= range.start))}"
                class="w-full">
                <ng-template #inputicon let-clickCallBack="clickCallBack">
                    <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                </ng-template>
            </p-datepicker>
            <p-message *ngIf="submitted && i === 0 && !range.end" severity="error" variant="simple"
                size="small">L'heure de fin est obligatoire</p-message>
            <p-message *ngIf="submitted && i > 0 && range.end && !range.start" severity="error" variant="simple"
                size="small">Veuillez aussi renseigner l'heure de début</p-message>
            <!-- <p-message *ngIf="submitted && range.start && range.end && range.end <= range.start" severity="error" variant="simple"
                size="small">L'heure de fin doit être supérieure à l'heure de début</p-message> -->
        </div>

        <!-- Boutons d'ajout/suppression -->
        <div class="flex gap-2 mt-2 sm:col-span-2">
            <p-button *ngIf="i === 0"
                icon="pi pi-plus"
                (click)="addTimeRange()"
                [disabled]="timeRanges.length >= 2"
                severity="secondary"
                label="Ajouter une autre tranche horaire">
            </p-button>

            <p-button
                *ngIf="timeRanges.length > 1 && i === timeRanges.length - 1"
                icon="pi pi-minus"
                (click)="removeTimeRange()"
                severity="danger">
            </p-button>
        </div>
    </div>
</div>

            <div class="mb-4">
                <label class="block font-bold mb-2">Type des horaires</label>
                <div class="flex items-center gap-4">
                    <div class="flex items-center">
                        <p-radiobutton
                            inputId="HO"
                            name="horaireType"
                            value="HO"
                            [(ngModel)]="astreinte.TypeHOHNO">
                        </p-radiobutton>
                        <label for="HO" class="leading-none ml-2">HO</label>
                    </div>
                    <div class="flex items-center">
                        <p-radiobutton
                            inputId="HNO"
                            name="horaireType"
                            value="HNO"
                            [(ngModel)]="astreinte.TypeHOHNO">
                        </p-radiobutton>
                        <label for="HNO" class="leading-none ml-2">HNO</label>
                    </div>
                </div>
                <p-message *ngIf="submitted && !astreinte.TypeHOHNO" severity="error" variant="simple"
                    size="small">Le type d'horaire est obligatoire</p-message>
            </div>

           <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <!-- Priorité -->
                <div class="mb-4">
                    <label class="block font-bold mb-2">Priorité <span class="text-red-500">*</span></label>
                    <p-select [(ngModel)]="prioriteValue" [options]="prioriteValues" placeholder="Sélectionner la priorité" class="w-full"
                     [filter]="true" />
                    <p-message *ngIf="submitted && !prioriteValue" severity="error" variant="simple"
                        size="small">La priorité est obligatoire</p-message>
                </div>
                
                <!-- Commentaire -->
                <div class="mb-4">
                    <label class="block font-bold mb-2">Commentaire</label>
                    <textarea pTextarea [(ngModel)]="astreinte.Commentaire" placeholder="Saisir votre commentaire ..." class="w-full" 
                        [autoResize]="true" [rows]="1" [cols]="30"></textarea>
                </div>
            </div>

            <p-divider class="w-full bg-surface-200"></p-divider>

            <div class="font-semibold text-xl">Les critères</div>
            <div class="grid grid-cols-1 sm:grid-cols-1 gap-1">
                <!-- Affichage des critères existants -->
                <div *ngIf="criteres.length > 0">
                    <div *ngFor="let critere of criteres ; let i = index" class="mb-4">
                        <label class="block font-bold mb-2">{{critere.Libelle}}</label>
                        <input type="text" pInputText [(ngModel)]="critereValues[critere.Critere]" class="w-full" />
                    </div>
                </div>
                <div *ngIf="criteres.length === 0">
                    <p-message severity="info" variant="simple" size="small">Aucun critère défini</p-message>
                </div>
            </div>

            <p-divider class="w-full bg-surface-200"></p-divider>

            <div class="font-semibold text-xl">Astreinte principale <span class="text-red-500">*</span></div>
            <p-select optionLabel="Astreinte_Nom" [options]="astreintesList" [filter]="true" [checkmark]="true" [showClear]="true"
                [(ngModel)]="selectedAstreintePrincipale" placeholder="Sélectionner une astreinte principale"
                class="w-full" appendTo="body" dropdownPosition="auto"></p-select>
            <p-message *ngIf="submitted && !selectedAstreintePrincipale" severity="error" variant="simple"
                size="small">L'astreinte principale est obligatoire</p-message>

            <!-- Section Escalade -->
            <div class="font-semibold text-xl">Les escalades</div>

            <!-- Bouton pour ajouter la première escalade -->
            <div *ngIf="getEscaladeLevels().length === 0">
                <p-button label="Ajouter une escalade" icon="pi pi-plus" (click)="addEscaladeLevel(0)"
                    severity="secondary"></p-button>
            </div>

            <div *ngIf="getEscaladeLevels().length > 0">
                <div *ngFor="let level of getEscaladeLevels()"
                    class="mb-4 p-4 border-round border-1 surface-border">
                    <div class="flex items-center gap-2 mb-8">
                        <div class="flex-grow">
                            <label class="block font-bold mb-2">Escalade {{level}}</label>
                            <p-select [options]="astreintesList" appendTo="body" dropdownPosition="auto" [filter]="true" [checkmark]="true"
                                [(ngModel)]="selectedEscalades[level].astreinte"
                                optionLabel="Astreinte_Nom" placeholder="Sélectionner" class="w-full">
                            </p-select>
                        </div>
                        <div class="flex gap-2 mt-5">
                            <p-button *ngIf="level === getEscaladeLevels().length && level < maxEscaladeLevels"
                                icon="pi pi-plus" (click)="addEscaladeLevel(level)"
                                [disabled]="!selectedEscalades[level].astreinte" severity="secondary"></p-button>

                            <p-button icon="pi pi-minus" (click)="removeEscaladeLevel(level)" severity="danger"></p-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </ng-template>

    <ng-template #footer>
        <p-button label="Annuler" icon="pi pi-times" text (click)="hideEditDialog()" />
        <p-button label="Enregistrer" icon="pi pi-save" (click)="validateAndUpdate()" [disabled]="isDisable" />
    </ng-template>
</p-dialog>

    </p-tabpanel>

            <!-- Gestion des critères -->

    <p-tabpanel [value]="1">
<!-- Section Critères -->
<div class="font-semibold text-xl mb-4">Gestion des critères</div>

<!-- Bouton si aucun critère -->
<div *ngIf="criteres.length === 0">
  <p-button label="Ajouter un critère" icon="pi pi-plus"
    (click)="addCritere(0)" severity="secondary">
  </p-button>
</div>

<!-- Liste des critères -->
<div *ngIf="criteres.length > 0">
  <div *ngFor="let critere of criteres; let i = index"
       class="mb-4 p-4 border-round border-1 surface-border">

    <div class="flex items-center justify-between mb-3">
      <div class="font-bold">Critère {{i + 1}}</div>

      <!-- Boutons alignés -->
      <div class="flex gap-2">
        <p-button
          icon="pi pi-refresh"
          severity="secondary"
          [disabled]="!critere.modified"
          (click)="resetCritere(i)">
        </p-button>

        <p-button
          icon="pi pi-save"
          severity="primary"
          [disabled]="!isSaveEnabled(critere)"
          (click)="saveOrUpdateCritere(i)">
        </p-button>
      </div>
    </div>

    <!-- Libellé -->
    <div class="mb-3">
      <label class="block font-bold mb-1">Libellé</label>
      <input type="text" pInputText class="w-full"
             [(ngModel)]="critere.Libelle"
             (ngModelChange)="markModified(i)"
             placeholder="Saisir le libellé"
             required />
      <small class="text-red-500"
             *ngIf="isAddMode(critere) && !critere.Libelle">
        Le libellé est requis
      </small>
    </div>

    <!-- Table + Colonne sur la même ligne -->
    <div class="flex gap-4 mb-3">
      <!-- Table -->
      <div class="flex-1">
        <label class="block font-bold mb-1">Table</label>
        <p-dropdown
          [options]="tablesList"
          optionLabel="nom"
          optionValue="nom"
          [(ngModel)]="critere.TableRecherche"
          (ngModelChange)="markModified(i)"
          placeholder="Nom Table"
          [filter]="true" [checkmark]="true" [showClear]="true"
          class="w-full"
          required>
        </p-dropdown>
        <small class="text-red-500"
               *ngIf="(!critere.TableRecherche && isAddMode(critere)) || (!critere.TableRecherche && critere.modified)">
          La table est requise
        </small>
      </div>

      <!-- Colonne -->
      <div class="flex-1">
        <label class="block font-bold mb-1">Colonne</label>
        <p-dropdown
          [options]="colonnesDict[critere.TableRecherche] || []"
          optionLabel="nom"
          optionValue="nom"
          [(ngModel)]="critere.NomChamp"
          (ngModelChange)="markModified(i)"
          placeholder="Colonne"
          [filter]="true" [checkmark]="true" [showClear]="true"
          class="w-full"
          required>
        </p-dropdown>
        <small class="text-red-500"
               *ngIf="(!critere.NomChamp && isAddMode(critere)) || (!critere.NomChamp && critere.modified)">
          La colonne est requise
        </small>
      </div>
    </div>

    <!-- Boutons plus/moins -->
    <div class="flex gap-2 mt-3">
      <p-button *ngIf="i === criteres.length - 1 && criteres.length < 2"
        icon="pi pi-plus" severity="secondary"
        (click)="addCritere(i)"
        [disabled]="!critere.Libelle || !critere.TableRecherche || !critere.NomChamp">
      </p-button>

      <p-button icon="pi pi-minus" severity="danger"
        (click)="removeCritere(i)">
      </p-button>
    </div>
  </div>
</div>
<!-- Actions -->
<!-- <div class="flex justify-end gap-2 mt-4">
  <p-button label="Annuler" icon="pi pi-times" severity="secondary"
    (click)="resetCriteres()"></p-button>
  <p-button label="Enregistrer" icon="pi pi-save" severity="primary"
    (click)="saveCriteres()"></p-button>
</div> -->

    </p-tabpanel>


    </p-tabpanels>
     </p-tabs>

   </div>

    <p-confirmdialog [style]="{ width: '850px' }" />
    <p-toast />

</div>
